module.exports = __webpack_public_path__ + "static/media/coldfusion.d07d47af.png";